import React from "react";

export default function TopSvg() {
  return (
    <>
      <svg style={{ width: "100%" }}>
        <polyline
          fill="transparent"
          strokeWidth="3"
          points="0,25.400000000000002 177.48,25.400000000000002 197.20000000000002,50.800000000000004 246.5,50.800000000000004 266.22,76.2 709.92,76.2 739.5,50.800000000000004 788.8000000000001,50.800000000000004 808.52,25.400000000000002 986,25.400000000000002"
          stroke="#1677ff"
        >
          <animate
            attributeName="stroke-dasharray"
            attributeType="XML"
            from="0, 516.3591645180628, 0, 516.3591645180628"
            to="0, 0, 1032.7183290361256, 0"
            dur="3s"
            begin="0s"
            calcMode="spline"
            keyTimes="0;1"
            keySplines="0.4,1,0.49,0.98"
            repeatCount="indefinite"
          ></animate>
        </polyline>
        <polyline
          fill="transparent"
          strokeWidth="2"
          points="295.8,101.60000000000001 690.1999999999999,101.60000000000001"
          stroke="#FAD400"
        >
          <animate
            attributeName="stroke-dasharray"
            attributeType="XML"
            from="0, 197.19999999999996, 0, 197.19999999999996"
            to="0, 0, 394.3999999999999, 0"
            dur="3s"
            begin="0s"
            calcMode="spline"
            keyTimes="0;1"
            keySplines=".4,1,.49,.98"
            repeatCount="indefinite"
          ></animate>
        </polyline>
      </svg>
    </>
  );
}
